export default class Settings {
  constructor(settingsParams) {
    const defaultSettings = Settings.defaultSettings();
    const baseSettings = settingsParams || defaultSettings;
    this.eula = baseSettings.eula;
    this.displayPreferences = {
      theme: baseSettings.displayPreferences?.theme || defaultSettings.displayPreferences.theme,
      language: baseSettings.displayPreferences?.language || defaultSettings.displayPreferences.language,
      timeZone: baseSettings.displayPreferences?.timeZone || defaultSettings.displayPreferences.timeZone,
      timeFormat: baseSettings.displayPreferences?.timeFormat || defaultSettings.displayPreferences.timeFormat
    };
    this.additionalOptions = {
      enableNotifications: baseSettings.additionalOptions?.enableNotifications || defaultSettings.additionalOptions.enableNotifications,
      notificationSound: baseSettings.additionalOptions?.notificationSound || defaultSettings.additionalOptions.notificationSound,
     };
    this.interfaceState = {
      currentTab: baseSettings.interfaceState?.currentTab || defaultSettings.interfaceState.currentTab,
      currentConversation: baseSettings.interfaceState?.currentConversation || defaultSettings.interfaceState.currentConversation,
      contactsExpansionStates: baseSettings.interfaceState?.contactsExpansionStates || defaultSettings.interfaceState.contactsExpansionStates,
      favoriteContacts: baseSettings.interfaceState?.favoriteContacts || defaultSettings.interfaceState.favoriteContacts
    };
  }


  static defaultSettings() {
    let lang = navigator.language.split('-')[0];
    lang = lang === 'en' || lang === 'es' ? lang : 'en';

    return {
      eula: false,
      displayPreferences: {
        theme: 'default',
        language: lang,
        timeZone: 'America/New_York',
        timeFormat: 'h:mm A'
      },
      additionalOptions: {
        enableNotifications: true,
        notificationSound: 'off'
      },
      interfaceState: {
        currentTab: 'Messages',
        currentConversation: '',
        contactsExpansionStates: {},
        favoriteContacts: []
      }
    };
  }
}
